module.exports = __webpack_public_path__ + "static/assets/5bca6b3a9b72144dafb5cecab39092c0.gif";